/* ==========================================================================
   VITAL VIAL - Cart drawer
   Opens on cart-icon click and after add-to-cart. Re-renders from the server
   whenever the cart changes, so totals and the shipping bar stay accurate.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var release = null, opener = null;

  function el() { return document.querySelector('[data-vv-cart-drawer]'); }

  function open() {
    var d = el();
    if (!d) return;
    opener = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vv-no-scroll');
    var panel = d.querySelector('.vv-drawer-cart__panel');
    if (window.vvTrapFocus && panel) release = window.vvTrapFocus(panel, close);
  }

  function close() {
    var d = el();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vv-no-scroll');
    if (release) { release(); release = null; }
    if (opener && opener.focus) opener.focus();
  }

  window.vvCartDrawer = { open: open, close: close };

  /* ---- Re-render from the server --------------------------------------- */
  function refresh(thenOpen) {
    var d = el();
    if (!d) return;
    var m = (d.closest('[id^="shopify-section-"]') || {}).id || '';
    var id = m.replace('shopify-section-', '');
    if (!id) return;

    fetch(ROOT + '?section_id=' + id)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-vv-cart-drawer]');
        if (!fresh) return;
        var wasOpen = d.classList.contains('is-open');
        d.innerHTML = fresh.innerHTML;
        if (wasOpen || thenOpen) open();
      })
      .catch(function () {});
  }

  /* ---- Triggers --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vv-cart-drawer-close]')) { e.preventDefault(); close(); return; }

    // Cart icon opens the drawer rather than navigating
    var cartLink = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (cartLink && el() && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      refresh(true);
    }
  });

  document.addEventListener('keydown', function (e) {
    var d = el();
    if (e.key === 'Escape' && d && d.classList.contains('is-open')) close();
  });

  // Open automatically after a successful add-to-cart
  if (window.vvBus) {
    window.vvBus.on('cart:updated', function () { refresh(true); });
  }
  document.addEventListener('cart:refresh', function () { refresh(false); });
})();
